// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3A-R7","visuallyhidden":"_1LzSU","hide-text":"_2LRZO","center":"_2fpyN","noprint":"MIcIV","subheading":"_1bABh"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-subheading/styles/Subheading_Factbox.scss
 ** module id = 952
 ** module chunks = 1
 **/